<template>
    <div id="app">
      <Header />
        <router-view></router-view>
      <Footer />
    </div>
  </template>
  
  <script>
  import Header from './components/AppHeader.vue';
  import Footer from './components/AppFooter.vue';
  
  export default {
    name: 'App',
    components: {
      Header,
      Footer,
    },
  };
  </script>
  
  <style>
  /* Global styles */
  </style>
  